import { CalculatorKey } from '@/ts/composables/useCalculator';
import { Period } from '@/ts/composables/usePeriod';

type CalculatorPeriodMap = {
  [key in CalculatorKey]: [Period, [number, number]][];
}

export const CALCULATOR_PERIOD_MAP: CalculatorPeriodMap = {
  'performance': [
    [Period.OneDay, [-0.03, 0.03]],
    [Period.TwoDay, [-0.03, 0.03]],
    [Period.FiveDay, [-0.06, 0.06]],
    [Period.OneMonth, [-0.1, 0.1]],
    [Period.TwoMonth, [-0.15, 0.15]],
    [Period.ThreeMonth, [-0.2, 0.2]],
    [Period.SixMonth, [-0.5, 0.5]],
    [Period.NineMonth, [-0.75, 0.75]],
    [Period.OneYear, [-0.75, 0.75]]
  ],
  'sctr': [
    [Period.Latest, [0, 100]],
    [Period.OneDay, [-11, 11]],
    [Period.TwoDay, [-15, 15]],
    [Period.FiveDay, [-25, 25]],
    [Period.OneMonth, [-50, 50]],
    [Period.TwoMonth, [-65, 65]],
    [Period.ThreeMonth, [-200, 200]],
    [Period.SixMonth, [-200, 200]],
    [Period.NineMonth, [-200, 200]],
    [Period.OneYear, [-200, 200]]
  ],
  'updown': [
    [Period.OneDay, [-1, 1]],
    [Period.TwoDay, [-2, 2]],
    [Period.FiveDay, [-3, 3]],
    [Period.OneMonth, [-8, 8]],
    [Period.TwoMonth, [-10, 10]],
    [Period.ThreeMonth, [-15, 15]],
    [Period.SixMonth, [-24, 24]],
    [Period.NineMonth, [-30, 30]],
    [Period.OneYear, [-36, 36]]
  ],
  'rsi': [
    [Period.Latest, [10, 90]],
    [Period.OneDay, [-10, 10]],
    [Period.TwoDay, [-12, 12]],
    [Period.FiveDay, [-20, 20]],
    [Period.OneMonth, [-30, 30]],
    [Period.TwoMonth, [-36, 36]],
    [Period.ThreeMonth, [-40, 40]],
    [Period.SixMonth, [-45, 45]],
    [Period.NineMonth, [-50, 50]],
    [Period.OneYear, [-50, 50]]
  ],
  'ppo': [
    [Period.Latest, [-0.1, 0.1]],
    [Period.OneDay, [-0.01, 0.01]],
    [Period.TwoDay, [-0.02, 0.02]],
    [Period.FiveDay, [-0.03, 0.03]],
    [Period.OneMonth, [-0.05, 0.05]],
    [Period.TwoMonth, [-0.07, 0.07]],
    [Period.ThreeMonth, [-0.09, 0.09]],
    [Period.SixMonth, [-0.09, 0.09]],
    [Period.NineMonth, [-0.1, 0.1]],
    [Period.OneYear, [-0.12, 0.12]]
  ],
  'bbwidth': [
    [Period.Latest, [0, 100]],
    [Period.OneDay, [-3, 3]],
    [Period.TwoDay, [-5, 5]],
    [Period.FiveDay, [-10, 10]],
    [Period.OneMonth, [-25, 25]],
    [Period.TwoMonth, [-25, 25]],
    [Period.ThreeMonth, [-25, 25]],
    [Period.SixMonth, [-25, 25]],
    [Period.NineMonth, [-30, 30]],
    [Period.OneYear, [-40, 40]]
  ],
  'bbposition': [
    [Period.Latest, [-100, 100]],
    [Period.OneDay, [-75, 75]],
    [Period.TwoDay, [-90, 90]],
    [Period.FiveDay, [-150, 150]],
    [Period.OneMonth, [-200, 200]],
    [Period.TwoMonth, [-220, 220]],
    [Period.ThreeMonth, [-220, 220]],
    [Period.SixMonth, [-250, 250]],
    [Period.NineMonth, [-250, 250]],
    [Period.OneYear, [-250, 250]]
  ],
  'stochrsi': [
    [Period.Latest, [0, 1]],
    [Period.OneDay, [-1, 1]],
    [Period.TwoDay, [-1, 1]],
    [Period.FiveDay, [-1, 1]],
    [Period.OneMonth, [-1, 1]],
    [Period.TwoMonth, [-1, 1]],
    [Period.ThreeMonth, [-1, 1]],
    [Period.SixMonth, [-1, 1]],
    [Period.NineMonth, [-1, 1]],
    [Period.OneYear, [-1, 1]]
  ],
  'aroon': [
    [Period.Latest, [-100, 100]],
    [Period.OneDay, [-50, 50]],
    [Period.TwoDay, [-75, 75]],
    [Period.FiveDay, [-100, 100]],
    [Period.OneMonth, [-150, 150]],
    [Period.TwoMonth, [-200, 200]],
    [Period.ThreeMonth, [-200, 200]],
    [Period.SixMonth, [-200, 200]],
    [Period.NineMonth, [-200, 200]],
    [Period.OneYear, [-100, 100]] // Not sure why it gets to cap off at around 96 after a year
  ],
  'fullstoch': [
    [Period.Latest, [0, 1]],
    [Period.OneDay, [-0.5, 0.5]],
    [Period.TwoDay, [-0.5, 0.5]],
    [Period.FiveDay, [-0.5, 0.5]],
    [Period.OneMonth, [-1, 1]],
    [Period.TwoMonth, [-1, 1]],
    [Period.ThreeMonth, [-1, 1]],
    [Period.SixMonth, [-1, 1]],
    [Period.NineMonth, [-1, 1]],
    [Period.OneYear, [-1, 1]]
  ]
};